import { BnAction } from '../../common/bn-action';

class DeleteUser extends BnAction {
  constructor() {
    super();
    this.actionname = 'delete-user';
    this.destructive = true;
    this.errortext = 'Failed to delete user';
    this.successtext = 'User has been deleted';
    this.submittext = 'Delete User (Admin only)';
  }

  preSubmit() {
    const confirmMessage = 'Are you sure you want to delete this user? This action can not be undone.';
    return window.confirm(confirmMessage);
  }
}

window.customElements.define('delete-user', DeleteUser);
